import { NgModule } from '@angular/core';
import { LoaderComponent } from './components/loader/loader.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, NgIf } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ValidationMessageComponent } from './components/validation-messages/validation-messages.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PaginationComponent } from './components/pagination/pagination.component';
import { NumberOnlyDirective } from './directives/numbers-only.directive';
import { ShowHidePasswordDirective } from './directives/show-hide-password.directive';
import { RefreshIcon } from '../../assets/icons/Refresh.icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import {
  BaseChartDirective,
  provideCharts,
  withDefaultRegisterables,
} from 'ng2-charts';
// import { FlowDesignerComponent } from './components/flow-designer/flow-designer.component';
import { HasFeatureDirective } from './directives/has-feature.directive';
import { SearchBarComponent } from './components/search-bar/search-bar.component';

@NgModule({
  declarations: [
    LoaderComponent,
    ValidationMessageComponent,
    PaginationComponent,
    NumberOnlyDirective,
    ShowHidePasswordDirective,
    DashboardComponent,
    // FlowDesignerComponent,
    HasFeatureDirective,
    SearchBarComponent,
  ],
  imports: [
    NgIf,
    FormsModule,
    MatSnackBarModule,
    MatDialogModule,
    CommonModule,
    RefreshIcon,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatMenuModule,
    MatSelectModule,
    BaseChartDirective,
  ],
  exports: [
    LoaderComponent,
    ValidationMessageComponent,
    PaginationComponent,
    NumberOnlyDirective,
    ShowHidePasswordDirective,
    HasFeatureDirective,
    SearchBarComponent,
    // BatchCallsListComponent,
    // InfiniteScrollDirective,
  ],
  providers: [provideCharts(withDefaultRegisterables())],
})
export class SharedModule {}
